import { IUserState } from '../../redux/reducers';
import { getUserTariff } from '../user';

export const getAnalyticsBrand = (user: IUserState) => {
  const { cianUserId, agentAccountType } = user;
  const { isBuilder, isBase, isPro } = getUserTariff(user);

  let creator;

  switch (true) {
    case isBuilder:
      creator = 'developer';

      break;

    case isBase || isPro:
      creator = 'realtor_prof';

      break;

    case !!agentAccountType:
      creator = 'physical';

      break;
  }

  return [cianUserId, creator].filter(Boolean).join('/') || undefined;
};
